//========== About Section Component ==========

import React from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import profileImage from "../../assets/img/About-img/My-Photo.webp";
import "./about.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const About = () => {
  const controls = useAnimation();
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: false,
    threshold: 0.5
  });
  React.useEffect(() => {
    if (inView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [controls, inView]);
  const variants = {
    hidden: {
      opacity: 0,
      y: 50
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        duration: 1.5
      }
    }
  };
  return /*#__PURE__*/_jsxs(motion.section, {
    className: "about",
    id: "about",
    ref: ref,
    initial: "hidden",
    animate: controls,
    variants: variants,
    children: [/*#__PURE__*/_jsxs("h2", {
      className: "heading",
      children: [/*#__PURE__*/_jsx("i", {
        className: "fas fa-user-alt"
      }), " About", " ", /*#__PURE__*/_jsx("span", {
        className: "meSpan",
        children: "Me"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "row",
      children: [/*#__PURE__*/_jsx(motion.div, {
        className: "image",
        variants: {
          hidden: {
            opacity: 0,
            y: 50
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              delay: 0.5,
              duration: 1.2,
              ease: "easeInOut"
            }
          }
        },
        children: /*#__PURE__*/_jsx("img", {
          draggable: "false",
          className: "tilt",
          src: profileImage,
          alt: "My Personal Pic"
        })
      }), /*#__PURE__*/_jsxs(motion.div, {
        className: "content",
        variants: variants,
        children: [/*#__PURE__*/_jsx("h3", {
          children: "I'm Mohamed Salem"
        }), /*#__PURE__*/_jsx("span", {
          className: "tag",
          children: "Front-End Developer"
        }), /*#__PURE__*/_jsx("p", {
          children: "I am a passionate front-end software developer. My aim is to make people's lives better & easier by developing applications and websites. I also love to teach coding as I believe that programming can empower people to achieve their full potential and live a better life."
        }), /*#__PURE__*/_jsx("div", {
          className: "resumebtn",
          children: /*#__PURE__*/_jsxs("a", {
            href: "https://drive.google.com/file/d/1hw4maSqPz0yWxfCPuXOkCAw9bhf07uXj/view?usp=sharing",
            target: "_blank",
            rel: "noopener noreferrer",
            className: "btn",
            children: [/*#__PURE__*/_jsxs("span", {
              children: [/*#__PURE__*/_jsx("i", {
                className: "fas fa-file-pdf"
              }), " Resume"]
            }), /*#__PURE__*/_jsx("i", {
              className: "fas fa-chevron-right"
            })]
          })
        })]
      })]
    })]
  });
};
export default About;